<template>
  <div class="IntroSlide3 lxn-w100 lxn-viewWithMaxWidth">
    <div class="IntroSlide3-d0">
      <CurveWithSvg :hideCurve="true">
        <template v-slot:svg>
          <svg class="lxn-w100 lxn-h100 lxn-display-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250"><circle cx="125" cy="125" r="125" fill="#f36c4f"/><path d="M56.72 116.13c-.9-5.47 1.17-9.85 4.77-13.62 3.57-3.75 7.88-6.4 12.4-8.66 8.13-4.07 16.7-6.82 25.48-8.9 14.26-3.4 28.68-5.6 43.37-5.25 9.37.22 18.55 1.63 27.3 5.3 6.84 2.87 12.82 7.02 17.8 12.67 5.58 6.32 8.43 13.84 9.28 22.26.16 1.56.2 3.13.2 4.7-.1 4.16-.62 8.26-1.8 12.25-3.1 10.45-9.08 18.46-18.64 23.4-5.9 3.04-12.25 3.95-18.72 4.16-5.25.17-10.48-.32-15.68-1.05-10.2-1.43-20.14-4.05-29.88-7.45-9.88-3.45-19.48-7.62-28.6-12.9-6.57-3.8-12.87-7.98-18.43-13.28-4-3.82-7.46-8-8.9-13.6zm94.96 23.83c1.5-.02 3.54-.34 5.3-1.63 1.6-1.17 1.56-2.8-.23-3.65-3.5-1.63-7-1.4-10.28.63-1.72 1.07-1.57 2.7.2 3.7 1.37.77 2.86.95 5 .95z" fill="#fefefe"/><path d="M56.72 116.13c1.42 5.6 4.88 9.78 8.88 13.6 5.56 5.3 11.86 9.5 18.43 13.28 9.12 5.27 18.72 9.44 28.6 12.9 9.74 3.4 19.67 6.02 29.88 7.45 5.2.73 10.43 1.22 15.68 1.05 6.47-.2 12.84-1.13 18.72-4.16 9.55-4.93 15.54-12.93 18.64-23.4 1.18-4 1.7-8.1 1.8-12.25.17.13.16.32.16.5-.15 5.03-.14 10.08-.5 15.1-.52 6.93-3.52 12.77-8.24 17.6-6.45 6.6-14.2 10.52-23.23 11.77-7.93 1.1-15.87.92-23.8.02-22.03-2.5-43.2-8.48-63.58-17.4-4.62-2.02-9.1-4.33-13.34-7.14-2.1-1.4-4.1-2.93-5.82-4.83-.96-1.06-1.76-2.22-2.25-3.6-.4-1.16-.08-2.3-.07-3.46l.01-10.5.03-6.53z" fill="#e0e1e1"/><path d="M151.68 139.96c-2.13.01-3.62-.18-5-.94-1.78-1-1.93-2.63-.2-3.7 3.28-2.04 6.8-2.27 10.28-.63 1.8.83 1.84 2.47.23 3.65-1.77 1.27-3.8 1.6-5.3 1.62z" fill="#1fa4dd"/></svg>
        </template>
      </CurveWithSvg>
    </div>
    <div :class="[$store.getters.language.font, $store.getters.language.directionClass]" class="IntroSlide3-title lxn-w100 lxn-title lxn-text-center">
      {{$store.getters.language.texts.IntroSlide3_title}}
    </div>
    <div :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]" class="IntroSlide3-text lxn-w100 lxn-text lxn-text-justify">
      {{$store.getters.language.texts.IntroSlide3_text}}
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CurveWithSvg from '@/components/CurveWithSvg.vue'

export default {
  name: 'IntroSlide3',
  components: {
    CurveWithSvg,
  },
  data: function() {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>

<style>
  .IntroSlide3 {
    background-color: transparent;
    min-height: 300px;
  }
  .IntroSlide3-d0 {
    height: 40vh;
  }
  .IntroSlide3-title {
    margin-top: 20px;
    height: 30px;
    color: #1EA5DE;
    line-height: 30px;
  }
  .IntroSlide3-text {
    color: #53636C;
    margin-top: 20px;
  }
</style>
